import React from "react";
import clsx from "clsx";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import CheckCrossIcons from "../../HOC/FunctionComponents/CheckCrossIcons";

export default function WaybillA4(props) {
  const { t } = useTranslation();
  const {
    shipment,
    shipmentIndex,
    classes,
    threeCopies,
    threeDifferent,
    oneCopy,
    logoImg,
    data,
    rtsShipment,
    currency,
    isBatch,
  } = props;

  return (
    <div
      key={shipmentIndex}
      className={clsx(classes.receipt, {
        [classes.receiptSmall]: threeCopies || threeDifferent || oneCopy,
      })}
    >
      <div className={classes.header}>
        <div>{logoImg}</div>
        <div style={{ flexGrow: 1 }}>
          <p className={classes.reportHeader}>
            {data?.organization?.reportHeader}
          </p>
        </div>
        <div className={clsx(classes.barcode, classes.centerContent)}>
          *{shipment?.code}*
        </div>
      </div>
      <div className={classes.body}>
        {/********************** Right **********************/}
        <div
          className={clsx(classes.section, classes.marginRight1)}
          style={{ width: "57%" }}
        >
          <div
            className={clsx(
              classes.dFlex,
              classes.container,
              classes.tableBorder
            )}
          >
            <div className={clsx(classes.dFlex, classes.topHeaders)}>
              <Box
                className={clsx(
                  classes.width50,
                  classes.tableHeader,
                  classes.leftRadius,
                  classes.centerContent
                )}
                sx={{ mr: 1, border: "1px solid black" }}
              >
                <Typography variant="h6">{shipment?.type?.name}</Typography>
              </Box>
              <Box
                sx={{ border: "1px solid black" }}
                className={clsx(
                  classes.width50,
                  classes.tableHeader,
                  classes.rightRadius,
                  classes.centerContent
                )}
              >
                <Box
                  style={{ fontSize: 14, mr: 1 }}
                  className={clsx(classes.width50, classes.tableCell)}
                >
                  {t("packageOpen")}
                </Box>
                <div
                  style={{ alignItems: "end" }}
                  className={clsx(classes.width50, classes.tableCell)}
                >
                  {!isBatch && (
                    <CheckCrossIcons
                      active={shipment?.openable?.code === "Y"}
                    />
                  )}
                </div>
              </Box>
            </div>

            <div
              className={clsx(
                classes.dFlex,
                classes.details,
                classes.tableBorder,
                classes.borderRadius
              )}
            >
              <div className={clsx(classes.flexChild, classes.borderBottom)}>
                <div
                  className={clsx(
                    classes.width21,
                    classes.tableCell,
                    classes.borderRight
                  )}
                >
                  {t("recipient")}
                </div>
                <div className={clsx(classes.tableCell, classes.width79)}>
                  {shipment?.recipientName}
                </div>
              </div>

              <div className={clsx(classes.flexChild, classes.borderBottom)}>
                <div
                  className={clsx(
                    classes.width21,
                    classes.tableCell,
                    classes.borderRight
                  )}
                >
                  {t("phone")}
                </div>
                <div className={clsx(classes.tableCell, classes.width79)}>
                  {shipment?.recipientMobile && shipment?.recipientPhone
                    ? `${shipment?.recipientMobile} - ${shipment?.recipientPhone}`
                    : shipment?.recipientMobile ?? shipment?.recipientPhone}
                </div>
              </div>

              <div className={clsx(classes.flexChild, classes.borderBottom)}>
                <div
                  className={clsx(
                    classes.width21,
                    classes.tableCell,
                    classes.borderRight
                  )}
                >
                  {t("date")}
                </div>
                <div className={clsx(classes.tableCell, classes.width79)}>
                  {shipment?.date?.split(" ")[0]}
                </div>
              </div>

              <div className={clsx(classes.flexChild, classes.borderBottom)}>
                <div
                  className={clsx(
                    classes.width21,
                    classes.tableCell,
                    classes.borderRight
                  )}
                >
                  {t("destination")}
                </div>
                <div className={clsx(classes.tableCell, classes.width79)}>
                  {shipment?.recipientZone
                    ? shipment?.recipientZone?.name +
                    " - " +
                    shipment?.recipientSubzone?.name
                    : ""}
                </div>
              </div>

              <div className={clsx(classes.flexChild, classes.borderBottom)}>
                <div
                  className={clsx(
                    classes.width21,
                    classes.tableCell,
                    classes.borderRight
                  )}
                >
                  {t("address")}
                </div>
                <div className={clsx(classes.tableCell, classes.width79)}>
                  {shipment?.recipientAddress}
                </div>
              </div>

              <div className={clsx(classes.flexChild)}>
                <div
                  className={clsx(
                    classes.width21,
                    classes.tableCell,
                    classes.borderRight
                  )}
                >
                  {t("refNumber")}
                </div>
                <div className={clsx(classes.tableCell, classes.width79)}>
                  {shipment?.refNumber}
                </div>
              </div>
            </div>

            <div
              className={clsx(classes.borderRadius, classes.notes)}
              style={{ textAlign: "center", overflow: "hidden" }}
            >
              <div
                className={clsx(
                  classes.width100,
                  classes.tableHeader,
                  classes.height35,
                  classes.headerStyle,
                  classes.borderBottom
                )}
              >
                {t("notes")}
              </div>
              <div
                style={{ whiteSpace: "pre-line" }}
                className={clsx(classes.width100, classes.height65)}
              >
                {shipment?.notes}
              </div>
            </div>
          </div>
        </div>

        {/********************** left **********************/}

        <div className={classes.section} style={{ width: "42%" }}>
          <div
            className={clsx(
              classes.tableBorder,
              classes.dFlex,
              classes.container
            )}
          >
            <div className={clsx(classes.dFlex, classes.topHeaders)}>
              <div
                className={clsx(
                  classes.width100,
                  classes.tableHeader,
                  classes.borderRadius,
                  classes.centerContent
                )}
              >
                <div
                  className={clsx(
                    classes.width50,
                    classes.tableCell
                  )}
                  style={{ fontSize: 14, zIndex: 2 }}
                >
                  {t("collection")}
                </div>
                <div
                  className={clsx(
                    classes.width50,
                    classes.tableCell,
                    classes.centerContent
                  )}
                  style={{
                    flexDirection: "row",
                    alignContent: "center",
                  }}
                >
                  <Box
                    component="span"
                    sx={{ fontSize: "1.1rem", fontWeight: 500 }}
                  >
                    {rtsShipment ? 0 : shipment?.totalAmount}
                  </Box>
                  <Box component="span" pl="2px">
                    {!isBatch && currency}
                  </Box>
                </div>
              </div>
            </div>
            <div className={clsx(classes.dFlex)}
              style={{
                flex: "1 1 auto",
                minHeight: "calc(100% / 21 * 1.7)",
              }}>
              <Box
                sx={{ mr: 1, border: "1px solid black" }}
                className={clsx(
                  classes.width50,
                  classes.leftRadius,
                  classes.dFlex,
                  // classes.tableHeader
                )}
              >
                <div
                  className={clsx(classes.tableCell)}
                  style={{ fontSize: 12, zIndex: 2, width: "55%" }}
                >
                  {t("customerDueAmount")}
                </div>
                <div
                  className={clsx(
                    classes.tableCell,
                    classes.centerContent
                  )}
                  style={{
                    flexDirection: "row",
                    alignContent: "center",
                    width: "45%"
                  }}
                >
                  <Box
                    component="span"
                    sx={{ fontSize: 12, fontWeight: 500 }}
                  >
                    {rtsShipment ? 0 : shipment?.amount}
                  </Box>
                  <Box component="span" pl="2px">
                    {!isBatch && currency}
                  </Box>
                </div>
              </Box>

              <div
                style={{ border: "1px solid black" }}
                className={clsx(
                  classes.width50,
                  classes.dFlex,
                  classes.rightRadius,
                  // classes.tableHeader
                )}
              >
                <div
                  className={clsx(classes.tableCell)}
                  style={{ fontSize: 12, zIndex: 2, width: "55%" }}
                >
                  {t("deliveryFees")}
                </div>
                <div
                  className={clsx(
                    classes.tableCell,
                    classes.centerContent
                  )}
                  style={{
                    flexDirection: "row",
                    alignContent: "center",
                    width: "45%",
                  }}
                >
                  <Box
                    component="span"
                    sx={{ fontSize: 12, fontWeight: 500 }}
                  >
                    {shipment?.allDueFees}
                  </Box>
                  <Box component="span" pl="2px">
                    {!isBatch && currency}
                  </Box>
                </div>
              </div>
            </div>

            <div
              className={clsx(
                classes.tableBorder,
                classes.dFlex,
                classes.borderRadius,
                classes.details
              )}
            >
              <div className={clsx(classes.flexChild, classes.borderBottom)}>
                <div
                  className={clsx(
                    classes.width50,
                    classes.tableCell,
                    classes.borderRight
                  )}
                >
                  {t("pieceCount")}
                </div>
                <div
                  className={clsx(
                    classes.width50,
                    classes.tableCell,
                    classes.borderRight
                  )}
                >
                  {shipment?.piecesCount}
                </div>
                <div
                  className={clsx(
                    classes.width50,
                    classes.tableCell,
                    classes.borderRight
                  )}
                >
                  {t("weight")}
                </div>
                <div className={clsx(classes.width50, classes.tableCell)}>
                  {shipment?.weight}
                </div>
              </div>

              <div className={clsx(classes.flexChild, classes.borderBottom)}>
                <div
                  className={clsx(
                    classes.width28,
                    classes.tableCell,
                    classes.borderRight
                  )}
                >
                  {t("branch")}
                </div>
                <div className={clsx(classes.tableCell, classes.width72)}>
                  {shipment?.originBranch?.name}
                </div>
              </div>
              <div className={clsx(classes.flexChild, classes.borderBottom)}>
                <div
                  className={clsx(
                    classes.width28,
                    classes.tableCell,
                    classes.borderRight
                  )}
                >
                  {t("source")}
                </div>
                <div className={clsx(classes.tableCell, classes.width72)}>
                  {shipment?.senderZone
                    ? shipment?.senderZone?.name +
                    " - " +
                    shipment?.senderSubzone?.name
                    : ""}
                </div>
              </div>

              <div
                className={clsx(classes.flexChild, {
                  [classes.borderBottom]:
                    !shipment?.customer?.hideWaybillMobile,
                })}
              >
                <div
                  className={clsx(
                    classes.width28,
                    classes.tableCell,
                    classes.borderRight
                  )}
                >
                  {t("senderName")}
                </div>
                <div className={clsx(classes.tableCell, classes.width72)}>
                  {!isBatch &&
                    shipment?.customer?.code + "-" + shipment?.senderName}
                </div>
              </div>

              <div
                className={clsx(classes.flexChild, {
                  [classes.hideSenderPhone]:
                    shipment?.customer?.hideWaybillMobile,
                })}
              >
                <div
                  className={clsx(
                    classes.width28,
                    classes.tableCell,
                    classes.borderRight
                  )}
                >
                  {t("senderPhone")}
                </div>

                <div className={clsx(classes.tableCell, classes.width72)}>
                  {shipment?.senderMobile && shipment?.senderPhone
                    ? `${shipment?.senderMobile} - ${shipment?.senderPhone}`
                    : shipment?.senderMobile ?? shipment?.senderPhone}
                </div>
              </div>
            </div>

            <div
              className={clsx(classes.borderRadius, {
                [classes.height9]: shipment?.customer?.hideWaybillMobile,
              })}
              style={{
                textAlign: "center", overflow: "hidden", flex: "1 1 auto",
                minHeight: "calc(100% / 21 * 7)"
              }}
            >
              <div
                className={clsx(
                  classes.width100,
                  classes.tableHeader,
                  classes.height_3_13,
                  classes.headerStyle,
                  classes.borderBottom
                )}
              >
                {t("description")}
              </div>
              <div
                className={classes.width100}
                style={{
                  textAlign: "center",
                  wordBreak: "break-word",
                  padding: 5,
                  whiteSpace: "pre-line",
                  overflowWrap: "break-word",
                  MsWordBreak: "break-word",
                  MsHyphens: "auto",
                  MozHyphens: "auto",
                  WebkitHyphens: "auto",
                  hyphens: "auto",
                }}
              >
                {shipment?.description}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
